import {json2csv}  from 'json-2-csv';

const isInProgress = (assessment) => {
	return (assessment.started_on && !assessment.submitted_on) ? true : false;
}

/*
Returns:
{
	"elephant_id": {
		"elephant": Object,
		"assessment: Object || null
	}
}
*/
const getElephantLastAssessments = (elephants,assessments) => {
	const elephantStatus = elephants.reduce((acc,cur)=>{
		acc[cur.id] = {
			assessment: null,
			elephant: cur
		};
		return acc;
	},{});

	const elephantLastAssessments = assessments.reduce((acc,cur)=>{
		const record = acc[cur.elephant_id];
		if (record.assessment === null || cur.started_on > record.assessment.started_on) {
			acc[cur.elephant_id].assessment = cur;
		}
		return acc;
	},elephantStatus);

	return elephantLastAssessments;
}

const otherElephantsNearby = (elephants,filterElephant) => {
	return elephants.filter((cur)=>{
		return cur.id !== filterElephant.id;
	}).map((cur)=>{ 
		return {label: cur.name, value: cur.id};
	});
}


const assessmentCsvList = ({assessments, elephants, users}) => {

	const userName = (id) => {
		const temp = users.find((cur)=>cur.id === id);
		return (temp) ? temp.name : '';
	}

	const elephantName = (id) => {
		const temp = elephants.find((cur)=>cur.id === id);
		return (temp) ? temp.name : '';
	}


	const assessmentCsv = json2csv(assessments.map((cur)=>{
		const {report_path,report_rnage, report_title, section_a, section_b, section_c, section_c_incidents_of_aggression, sync, ...rest} = cur;
		return {
			...rest,
			elephant_name: elephantName(rest.elephant_id),
			user_name: userName(rest.user_id),
		};
	}));
	console.log(assessmentCsv);

	//const sectionaCsv = json2csv(
		
	const tempa = assessments.map((cur)=>{
		return cur.section_a || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync, ...rest} = cur
		return {
			...rest, 
			other_elephants_nearby: (rest.other_elephants_nearby.length > 0) ? rest.other_elephants_nearby.join(', ') : '',
			other_elephants_nearby_names: rest.other_elephants_nearby.map((id)=>(elephantName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	const sectionaCsv = json2csv(tempa);

	const tempb = assessments.map((cur)=>{
		return cur.section_b || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync,section_b_behaviors,...rest} = cur
		return {
			...rest, 
			other_elephants_nearby: (rest.other_elephants_nearby.length > 0) ? rest.other_elephants_nearby.join(', ') : '',
			other_elephants_nearby_names: rest.other_elephants_nearby.map((id)=>(elephantName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	const sectionbCsv = json2csv(tempb);


	const tempbdetailed = assessments.map((cur)=>{
		return cur.section_b || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		// cur is all the section_b records
		const {section_b_behaviors,assessment_id} = cur

		return (section_b_behaviors || []).map((cur)=>{
			return {...cur,assessment_id};
		});
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		// all section_b_behaviors
		const {sync,...rest} = cur
		return {
			...rest, 
			associated_elephants: (rest.associated_elephants.length > 0) ? rest.associated_elephants.join(', ') : '',
			associated_elephant_names: rest.associated_elephants.map((id)=>(elephantName(id))).join(', '),
		};
	})

	const sectionbdetailedCsv = json2csv(tempbdetailed);


	const tempc = assessments.map((cur)=>{
		return cur.section_c || [];
	})
	.reduce((acc,cur)=>{
		acc = acc.concat(cur);
		return acc;
	},[])
	.map((cur)=>{
		const {sync, ...rest} = cur
		return {
			...rest, 
			associated_elephants: (rest.associated_elephants.length > 0) ? rest.associated_elephants.join(', ') : '',
			associated_elephants_names: rest.associated_elephants.map((id)=>(elephantName(id))).join(', '),
			user_name: userName(rest.user_id),
		};
	});

	//console.log(tempc);

	const sectioncCsv = json2csv(tempc);

	const fileData = { 
		"assessment.csv": new TextEncoder().encode(assessmentCsv),
		"section_a.csv": new TextEncoder().encode(sectionaCsv),
		"section_b.csv": new TextEncoder().encode(sectionbCsv),
		"section_b_behavior.csv": new TextEncoder().encode(sectionbdetailedCsv),
		"section_c.csv": new TextEncoder().encode(sectioncCsv),
	};

	return fileData;
}


export {isInProgress, getElephantLastAssessments, otherElephantsNearby, assessmentCsvList };